export const CONTROLLERS_OPENED_MS = 2500
